import { render } from "./OrdiniPage.vue?vue&type=template&id=657c56e2"
import script from "./OrdiniPage.vue?vue&type=script&lang=js"
export * from "./OrdiniPage.vue?vue&type=script&lang=js"

import "@/css/OrdiniPage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__